import React, { useEffect, useState } from 'react';
import { Progress } from '@sravni/react-design-system';
import classNames from 'classnames';
import { useIsMobile } from '@sravni/react-utils';
import { Paper } from '../../../../../landing.common';
import { IFRAME_RESIZER_SCROLL_EVENT, PAGE } from '../../../../../../constants';
import { useSelection } from '../../../../../../store/reducers/selection';
import styles from './styles.module.scss';
import { DataLabel } from './components/data.label';
import { ProgressPicture } from './components/progress.picture';

type Props = {
    step: number;
    inProcess?: boolean;
};

export const FormProgress: React.FC<Props> = (props) => {
    const { step, inProcess } = props;
    const [topOffset, setTopOffset] = useState<number>(20);
    const isMobile = useIsMobile();
    const { page } = useSelection();

    useEffect(() => {
        if (page !== PAGE.CARDS_WHITELABEL) {
            return;
        }
        document.addEventListener(IFRAME_RESIZER_SCROLL_EVENT, iframeScrollHandler as EventListener, false);
        return () => {
            document.removeEventListener(IFRAME_RESIZER_SCROLL_EVENT, iframeScrollHandler as EventListener, false);
        };
    }, []);

    const iframeScrollHandler = (event: CustomEvent<number>) => {
        if (event.detail <= 0 && event.detail > -500) {
            const scrollY = Math.abs(event.detail);
            if (scrollY > 120) {
                setTopOffset(20 + scrollY);
            } else {
                setTopOffset(20);
            }
        }
    };

    const accuracyList: Record<number, string> = {
        1: 'Низкая',
        2: 'Средняя',
        3: 'Высокая',
        4: 'Максимальная',
    };

    const accuracy = accuracyList[step] || accuracyList[1];

    const percentList: Record<number, number> = {
        1: 30,
        2: 80,
        3: 95,
        4: 100,
    };

    const percent = percentList[step - 1] || 0;
    const nextPercent = (percentList[step] || 0) - percent;

    const stepList: Record<number, string> = {
        1: 'первый',
        2: 'второй',
        3: 'третий',
        4: 'четвертый',
    };

    const percentString = `+${nextPercent}% ${step > 1 ? 'к точности' : ''} за ${stepList[step] || ''} шаг`;
    const isPaperFixed = topOffset > 20 && !isMobile && page === PAGE.CARDS_WHITELABEL;

    return (
        <div className={classNames(styles.root, isPaperFixed ? styles.root_fixed : null)}>
            <Paper
                className={classNames(styles.paper, isPaperFixed ? styles.paper_fixed : null)}
                style={{ top: topOffset }}>
                <div className={styles.dataWrapper}>
                    <div className={styles.progressWrapper}>
                        <DataLabel loading={inProcess} value={accuracy} caption="Точность расчета" />
                        <Progress percent={percentList[step] || 100} className={styles.progressBar} />
                        <div className={styles.caption}>{percentString}</div>
                    </div>
                </div>
                <div className={styles.imageWrapper}>
                    <ProgressPicture step={step} />
                </div>
            </Paper>
        </div>
    );
};
